import { INotificationMessage } from "@fl/shared/src/types/messages";
import moment from "moment";
import React from "react";
import { Alert, Row } from "react-bootstrap";
import SortFunctions from "../../../utils/sortArrays";

interface IProps {
  messages: INotificationMessage[];
  remove: (key: string) => void;
}

const NotificationsItems: React.FC<IProps> = ({ messages, remove }) => {
  return (
    <div>
      {messages
        .sort((a, b) => new SortFunctions(a, b).sortDateAsc())
        .map((item, index) => (
          <div key={item.key}>
            <Alert
              variant={item.variant}
              onClose={() => {
                remove(item.key);
              }}
              dismissible
            >
              <Alert.Heading as="h5">
                #{(index + 1).toString().padStart(3, "0")}: {item.header}
              </Alert.Heading>

              <Row
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  marginLeft: "5px",
                }}
              >
                {moment(item.date).format("DD/MM/YY [às] HH:mm:ss")}
              </Row>

              <Row className="mt-2">
                <div
                  style={{ fontSize: "13px" }}
                  dangerouslySetInnerHTML={{
                    __html: item.message ? item.message : "",
                  }}
                />
              </Row>
            </Alert>
          </div>
        ))}
    </div>
  );
};

export default NotificationsItems;
